var styleDataHash = '01487da1';  
export const injectCss = (() => {
  var css = `.J24qL{border:0;height:100%;width:100%;z-index:0}.J24qL,.ytMu8{left:0;position:absolute;top:0}.ytMu8{bottom:0;right:0;z-index:3}._-7msT{height:0;padding-bottom:56.25%;position:relative}@supports not (contain:inline-size){@media only screen and (max-width:480px){._-7msT{min-width:auto}}}@container (width < 480px){._-7msT{min-width:auto}}.glob_fontElementMap,.qIhF-{font-family:var(--ricos-font-family,unset)}._1lrvM{--ricos-custom-p-font-size:14px;color:var(--ricos-custom-p-color,unset);display:block;font-family:var(--ricos-custom-p-font-family,unset);font-size:var(--ricos-custom-p-font-size,unset);font-style:var(--ricos-custom-p-font-style,unset);font-weight:var(--ricos-custom-p-font-weight,unset);justify-content:center;letter-spacing:var(--ricos-custom-p-letter-spacing,unset);line-height:var(--ricos-custom-p-line-height,unset);min-height:var(--ricos-custom-p-min-height,unset);padding-inline:16px;text-align:center;text-decoration:var(--ricos-custom-p-text-decoration,unset)}._1lrvM>span>a,._1lrvM>span>span{background-color:var(--ricos-custom-p-background-color,unset)}@supports not (contain:inline-size){@media only screen and (max-width:480px){._1lrvM{font-size:var(--ricos-custom-p-font-size,unset)}}}@container (width < 480px){._1lrvM{font-size:var(--ricos-custom-p-font-size,unset)}}.qRSwX{display:block!important;margin:0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});





